export const TEAM_TABLE_TYPE = {
  CORE: 'CORE',
  EXTRA: 'EXTRA'
};
